// Escape `<` so CMS-authored JSON cannot terminate an inline script tag.
export function serializeJsonLd(graph: unknown): string {
  return JSON.stringify(graph).replace(/</g, "\\u003c");
}
